import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.css';
function PageNotFound() {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/home" className="home-link">Go back to Home</Link>
    </div>
  );
}
export default PageNotFound;
